<template>
	<div
		id="app"
		class="app"
		data-cy="app"
	>
		<transition
			name="fade"
			mode="out-in"
		>
			<router-view />
		</transition>
	</div>
</template>

<script>
import { marketingMixins } from '@/mixins';

export default {
	name: 'App',
	mixins: [marketingMixins],
	mounted() {
		marketingMixins.initializeLogRocket();
		marketingMixins.insertFacebookPixel();
		marketingMixins.insertGA4Tag();
	},
};
</script>
